const cardsData = [
  {
    title: '独家深扒：某顶流偶像与经纪公司解约内幕全记录',
    summary: '多方信源交叉验证，还原这场震动娱乐圈的解约风波背后不为人知的利益博弈与合同陷阱。',
    tag: '深度爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20backstage%20dressing%20room%20with%20warm%20amber%20light%20through%20mirrors%2C%20luxurious%20but%20tense%20atmosphere%2C%20cinematic%20moody%20lighting%2C%20deep%20shadows%2C%20professional%20photography%20style%2C%20no%20faces%2C%20no%20text&width=720&height=480&seq=card-01&orientation=landscape',
  },
  {
    title: '知情人爆料：大热选秀节目投票系统存在严重漏洞',
    summary: '据参与节目制作的技术人员透露，投票数据存在被篡改的可能，多位选手排名与实际票数不符。',
    tag: '内幕曝光',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20voting%20screen%20with%20red%20warning%20glow%2C%20dark%20mysterious%20tech%20atmosphere%2C%20hacker%20aesthetic%2C%20warm%20crimson%20and%20amber%20highlights%2C%20cinematic%20style%2C%20no%20text%2C%20no%20faces&width=720&height=480&seq=card-02&orientation=landscape',
  },
  {
    title: '实锤来了：某知名网红人设彻底崩塌，时间线完整梳理',
    summary: '从第一次争议到最新实锤，我们按时间顺序完整还原这起引发全平台热议的人设崩塌事件。',
    tag: '实锤追踪',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20shattered%20glass%20effect%20with%20warm%20golden%20and%20crimson%20light%20refractions%2C%20dark%20moody%20background%2C%20cinematic%20photography%2C%20luxurious%20texture%2C%20no%20text%2C%20no%20faces&width=720&height=480&seq=card-03&orientation=landscape',
  },
  {
    title: '圈内人亲述：娱乐圈饭局文化背后的利益交换',
    summary: '匿名知情人士详细描述行业内部不成文的潜规则，揭示资源分配与利益输送的真实运作方式。',
    tag: '行业揭秘',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20private%20dining%20room%20with%20dim%20warm%20lighting%2C%20empty%20chairs%20around%20table%2C%20mysterious%20atmosphere%2C%20dark%20shadows%2C%20cinematic%20noir%20style%2C%20professional%20photography%2C%20no%20faces%2C%20no%20text&width=720&height=480&seq=card-04&orientation=landscape',
  },
  {
    title: '重磅：某跨国娱乐集团内部财务问题被调查',
    summary: '涉及旗下多名签约艺人的税务和合同问题，相关监管部门已介入，或将对整个行业产生深远影响。',
    tag: '重磅消息',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20investigation%20scene%20with%20documents%20silhouette%20and%20warm%20amber%20desk%20lamp%2C%20dark%20mysterious%20office%20atmosphere%2C%20cinematic%20lighting%2C%20professional%20noir%20style%2C%20no%20faces%2C%20no%20text&width=720&height=480&seq=card-05&orientation=landscape',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">精选爆料</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">编辑精选的深度爆料内容，每一篇都值得细读</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className={`group cursor-pointer bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.summary}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}